import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeRectangleVerticalIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.42 19.84V4.08H18.58V19.84H5.42ZM7.26 18H16.74V5.92H7.26V18Z" />
    </SvgIcon>
  );
});
